/**
 * 获取 uuid
 */
export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 是否有权限
 */
export function isAuth(key) {
  return JSON.parse(sessionStorage.getItem('permissions') || '[]').includes(key)
}

/**
 * 树形数据转换
 */
export function treeDataTranslate(
  data,
  id = 'id',
  pid = 'parentId'
) {
  const res = []
  const map = new Map()
  const visited = new Set()
  // 1️⃣ 拷贝一份（防止污染原数据）
  const list = data.map(item => ({ ...item }))
  // 2️⃣ 初始化
  for (const item of list) {
    item.children = []
    map.set(item[id], item)
  }
  // 3️⃣ 构建树
  for (const item of list) {
    const parent = map.get(item[pid])
    // ✅ 防自引用
    if (item[id] === item[pid]) continue
    // ✅ 防循环引用
    if (visited.has(item[id])) continue
    visited.add(item[id])
    if (parent) {
      parent.children.push(item)
    } else {
      res.push(item)
    }
  }
  return res
}

/**
 * 查找所有父节点
 */
export function getParent(data, nodeId) {
  const result = []

  function find(list, id) {
    for (const node of list) {
      if (node.id === id) {
        result.unshift(node)
        if (node.parentId) {
          find(data, node.parentId)
        }
        return true
      }
      if (node.children && find(node.children, id)) {
        return true
      }
    }
    return false
  }

  find(data, nodeId)
  return result
}

/**
 * 树转数组
 */
export function treeToArray(data, expandAll, parent = null, level = 1) {
  const tmp = []

  for (const record of data) {
    record._expanded = expandAll
    record._level = level
    if (parent) {
      record.parent = parent
    }
    tmp.push(record)

    if (record.children?.length) {
      tmp.push(...treeToArray(record.children, expandAll, record, level + 1))
    }
  }

  return tmp
}

/**
 * 深拷贝（简单版）
 */
export function deepClone(obj) {
  if (obj == null || typeof obj !== 'object') {
    return obj
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime())
  }

  if (obj instanceof RegExp) {
    return new RegExp(obj.source, obj.flags)
  }

  if (typeof obj.cloneNode === 'function') {
    return obj.cloneNode(true)
  }

  const result = Array.isArray(obj) ? [] : {}

  for (const key in obj) {
    result[key] = deepClone(obj[key])
  }

  return result
}

export const exportDefault = 'export default '

export const beautifierConf = {
  html: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'separate',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  },
  js: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'normal',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: true,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true
  }
}

/**
 * 首字母大写
 */
export function titleCase(str) {
  return str.replace(/(^|\s)[a-z]/g, l => l.toUpperCase())
}

/**
 * 搜索参数转换
 */
export function searchUtils(data) {
  return data.reduce((obj, item) => {
    if (item.type === 'picker') {
      if (item.value?.length === 2) {
        obj[item.prop] = {
          [`${item.prop}Start`]: item.value[0],
          [`${item.prop}End`]: item.value[1]
        }
      } else {
        obj[item.prop] = {}
      }
    } else if (item.type === 'inputCascade') {
      obj[item.prop] = item.code
    } else {
      obj[item.prop] = item.value
    }
    return obj
  }, {})
}

/**
 * 附件删除
 */
export function deleteFile(file, fileList) {
  const index = fileList.findIndex(f => f.uid === file.uid)
  if (index !== -1) {
    fileList.splice(index, 1)
  }
  return fileList
}